<template>
  <div id="app">
    <loadingOverlay :active="LoadingCounter > 0" />

    <!--
    <div class="navbar w-100">
      <div class="mplogo-small"></div>
    </div>
  -->

    <div class="input-container">
      <b-input-group size="lg" prepend="Address">
        <b-form-input v-model="address" @change="addressChanged"></b-form-input>
      </b-input-group>
    </div>

    <div class="gmap-container">


      <GmapMap map-type-id="terrain" style="width: 100%; height: 100%" :center="{ lat: centerLat, lng: centerLon }"
        :zoom="Zoom" @center_changed="updateCenter">
        <GmapMarker :key="index" v-for="(park, index) in parks " :icon="{
          url: 'map_icon_small.png'
        }" :title="park.name" :clickable="true" :position="{
          lat: park.lat,
          lng: park.lon,
        }">

          <GmapInfoWindow class="map-marker">
            <div class="map-marker">{{ park.name }}</div>
          </GmapInfoWindow>

        </GmapMarker>
      </GmapMap>
    </div>

    <div class="card-container position-absolute d-flex flex-column justify-content-end">
      <div class="mp-card">
        <div class="mp-card-logo"></div>
        <div class="mp-card-header">Have you found a Magical Park?</div>
        <div class="mp-card-text">Great! Download the app over wifi<br />visit the park, and enjoy!</div>
        <div class="mp-card-app-container">
          <img class="mp-card-app" @click="open('https://apps.apple.com/app/magical-park/id1278879990')"
            src="./assets/app_store.svg">
          <img class="mp-card-app"
            @click="open('https://play.google.com/store/apps/details?id=com.GeoARGames.MagicalPark2')"
            src="./assets/google_play.svg">
        </div>
      </div>
      <div class="mp-card-small d-flex flex-column mt-3">
        <div class="mp-card-header">Can't find a Magical Park?</div>
        <div class="mp-card-text">We can contact your local parks & recreation body on your behalf.</div>
        <div class="mp-card-button" @click="open('https://www.magicalpark.net/suggest-a-park')">Suggest a Park</div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import * as VueGoogleMaps from "vue2-google-maps";
import { GetMapAPIKey, GetParksCloseToAddressURL, GetParksCloseToLocationURL } from "../../shared/Shared";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Axios from 'axios';
import SimplePark from "../../shared/SimplePark";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


Vue.use(Loading);
Vue.component("loadingOverlay", Loading);

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueGoogleMaps, {
  load: {
    key: GetMapAPIKey(),
    libraries: "places,drawing,visualization", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

class MapData {
  centerLat = 0;
  centerLon = 0;
  address = "";
  parks: SimplePark[] = [];
  LoadingCounter = 0;
  Zoom = 3;
  infoWinOpen = false;
  newLat = 0;
  newLon = 0;
  timeoutHandler = 0;
}

export default Vue.extend({
  name: 'App',
  data() {
    return new MapData();
  },

  created() {


    if ("geolocation" in navigator) {
      // Prompt user for permission to access their location
      navigator.geolocation.getCurrentPosition((location) => {

        this.LoadingCounter++;
        this.newLat = location.coords.latitude;
        this.newLon = location.coords.longitude;

        Axios.get<SimplePark[]>(GetParksCloseToLocationURL(location.coords.latitude, location.coords.longitude))
          .then((result) => this.setParkLocation(result.data, "")).finally(() => {
            this.LoadingCounter--;
          });

      });
    }


  },

  methods: {

    open(url: string) {

      const tab = window.open(url, '_blank')
      if (tab) {
        tab.focus();
      }

    },

    updateCenter(center: { lat: () => number, lng: () => number }) {

      const newLat = center.lat();
      const newLon = center.lng();

      if (newLat == this.newLat && newLon == this.newLon) {
        return;
      }

      this.newLat = newLat;
      this.newLon = newLon;

      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
      }

      this.timeoutHandler = setTimeout(() => {

        this.timeoutHandler = 0;
        Axios.get<SimplePark[]>(GetParksCloseToLocationURL(this.newLat, this.newLon))

          .then((result) => {
            this.setParkLocation(result.data, "", true)
          });

      }, 1000);



    },

    setParkLocation(parks: SimplePark[], address = "", manualMove = false) {

      this.parks = parks;
      if (manualMove) {
        return;
      }

      let avgLat = 0;
      let avgLon = 0;

      if (parks.length) {
        for (const park of parks) {
          avgLat += park.lat;
          avgLon += park.lon;
        }
        this.centerLat = avgLat / parks.length;
        this.centerLon = avgLon / parks.length;
        this.Zoom = 10;
      }
      else {
        if (address) {
          alert("Could not find any parks within 100km of " + address);
        }
        else {
          alert("Could not find any parks within 100km of your current location");
        }
      }

    },

    addressChanged(address: string) {

      this.LoadingCounter++;
      Axios.get<SimplePark[]>(GetParksCloseToAddressURL(address, this.newLat, this.newLon))
        .then((result) => this.setParkLocation(result.data, address))
        .catch((err) => {
          alert("We cannot find a place called " + address + " close to you - please add more detail to the address");
        })
        .finally(() => {
          this.LoadingCounter--;
        });
    }
  }
});
</script>

<style lang="less">
#app {
  font-family: "Asap", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-weight: 500;
}

.fullscreen {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

body,
html,
#app {
  .fullscreen
}

.input-container {
  margin: 10px;
}

.gmap-container {
  position: absolute;
  top: 64px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

button.gm-ui-hover-effect {
  display: none !important;
}

.navbar {
  background-color: #365e2c;
  height: 106px;
  position: relative;
}

.mplogo-small {
  background-image: url("./assets/mplogo_small.png");
  width: 295px;
  height: 76px;
  top: 16px;
  position: absolute;
}

.card-container {
  pointer-events: none;
  top: 0px;
  left: 96px;
  bottom: 16px;
  right: 0px;
}

.mp-card {
  width: 356px;
  height: 192px;
  background-color: white;
  border-radius: 16px;
  margin-top: 5px;
  position: relative;
}

.mp-card-small {
  .mp-card;
}

.mp-card-header {
  font-size: 20px;
  top: 30px;
  position: absolute;
  left: 0px;
  right: 0px;
  color: #f37622;
  font-family: "Lilita One", sans-serif;
}

.mp-card-small .mp-card-header {
  top: 24px;
}

.mp-card-text {
  top: 62px;
  position: absolute;
  left: 32px;
  right: 32px;
  line-height: 20px;
}

.mp-card-small .mp-card-text {
  top: 56px;
}


.mp-card-button {
  position: absolute;
  left: 52px;
  right: 52px;
  height: 52px;
  background-color: #56207f;
  pointer-events: all;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  font-weight: bold;
  font-size: large;
}

.mp-card-small .mp-card-button {
  top: 120px;
}

.mp-card-app-container {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 124px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.mp-card-app {
  height: 46px;
  pointer-events: all;
  cursor: pointer;
  margin-left: 6px;
  margin-right: 6px;
}

.mp-card-logo {
  background-image: url("./assets/mplogo_large.png");
  position: absolute;
  width: 441px;
  height: 110px;
  top: -60px;
  left: -42.5px;
}

.map-marker {
  pointer-events: none;
  user-select: none;
}
</style>
